import { render, staticRenderFns } from "./ClaimPaymentManage.vue?vue&type=template&id=8e583fb0&"
import script from "./ClaimPaymentManage.vue?vue&type=script&lang=js&"
export * from "./ClaimPaymentManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports